import 'globalCommon/style/common.css';
import 'globalCommon/style/iconfont.css';
import 'globalCommon/style/reset.css';
import 'pcCommon/style/common.css';

import { gdprCom, ipPrompt } from '@umu/umu-prompt';
import 'babel-polyfill';
import { loadResource, registerBesChannels } from 'globalCommon/gdprResource';
import getUserInfo, { IUserInfo } from 'globalCommon/services/getUserInfo';
import isInitRegisterBtn from '../../../common/utils/isInitRegisterBtn';
import registerSentry from '../../../common/utils/sentry';
import { detectWebpSupport, detectAvifSupport } from '../../../common/utils/formatDetect';
import { applyForceFallback, watchPictureImgLoad, applyFormatActivation } from '../../../common/utils/pictureEnhance';
import { initHeader, initFooter } from 'globalCommon/utils/headerFooterRender';
import Cookies from 'globalCommon/utils/cookie';

if (document.body) {
    document.body.classList.add('locale-' + LOCALE.toLowerCase());
    document.body.classList.add('system-' + SYSTEM.toLowerCase());
}

detectWebpSupport();
detectAvifSupport();

declare global {
    interface Window {
        HomeHeader: any;
        HomeFooter: any;
    }
}

const initGDPR = (userId?: string) => {
    gdprCom({
        userId,
        platform: 'web',
        lang: LOCALE.toLowerCase(),
        onAgree: () => {
            loadResource();
        },
    });
};

function nextDay() {
    const now = Date.now();
    const tomorrow = new Date(now + 24 * 60 * 60 * 1000);
    tomorrow.setHours(0, 0, 0, 0)
    return tomorrow;
}

const IP_PROMPT_LOCAL_KEY = 'IP_PROMPT_LOCAL_KEY_V1';
const IP_PROMPT_COOKIE_KEY = 'ip_prompt';

function setPromptCookie() {
    Cookies.set(IP_PROMPT_COOKIE_KEY, new Date().toLocaleString(), { expires: nextDay() });
}

function showPrompt(userId?: string) {
    const localIPPrompt = localStorage.getItem(IP_PROMPT_LOCAL_KEY);
    // 基于 cookie 调整为每天弹出一次
    if (localIPPrompt !== null) {
        // 设置cookies
        const cookieValue = Cookies.get(IP_PROMPT_COOKIE_KEY);
        if (cookieValue === undefined) {
            localStorage.removeItem(IP_PROMPT_LOCAL_KEY)
        }
    }
    const commonConfig = {
        userId,
        stayFunc: initGDPR,
        onClose: setPromptCookie,
    };
    if (SYSTEM.toLowerCase() === 'en') {
        ipPrompt(
            [
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'CN',
                    from: 'UMU.COM',
                    to: 'umu.cn',
                    lang: 'cn',
                    mainland_1: '中国',
                    mainland_2: 'mainland China',
                    district_en: 'global',
                    district_cn: '国际',
                    district_jp: 'グローバル',
                },
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'JP',
                    from: 'UMU.COM',
                    to: 'umu.co',
                    lang: 'jp',
                    mainland_1: '日本',
                    mainland_2: 'Japan',
                    district_en: 'global',
                    district_cn: '国际',
                    district_jp: 'グローバル',
                },
            ],
            commonConfig,
        );
    } else if (SYSTEM.toLowerCase() === 'em') {
        ipPrompt(
            [
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'CN',
                    from: 'UMU.IO',
                    to: 'umu.cn',
                    lang: 'cn',
                    mainland_1: '中国',
                    mainland_2: 'mainland China',
                    district_en: 'European',
                    district_cn: '欧洲',
                    district_jp: 'ヨーロッパ',
                },
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'JP',
                    from: 'UMU.IO',
                    to: 'umu.co',
                    lang: 'jp',
                    mainland_1: '日本',
                    mainland_2: 'Japan',
                    district_en: 'European',
                    district_cn: '欧洲',
                    district_jp: 'ヨーロッパ',
                },
            ],
            commonConfig,
        );
    }  else if (SYSTEM.toLowerCase() === 'tw') {
        ipPrompt(
            [
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'CN',
                    from: 'UMU.TW',
                    to: 'umu.tw',
                    lang: 'cn',
                    mainland_1: '中国',
                    mainland_2: 'mainland China',
                    // @ts-expect-error 2322
                    district_en: 'Taiwan',
                    // @ts-expect-error 2322
                    district_cn: '台湾地区',
                    // @ts-expect-error 2322
                    district_jp: '台湾',
                },
                {
                    ...commonConfig,
                    platform: 'twww',
                    countryCode: 'JP',
                    from: 'UMU.TW',
                    to: 'umu.co',
                    lang: 'jp',
                    mainland_1: '日本',
                    mainland_2: 'Japan',
                    // @ts-expect-error 2322
                    district_en: 'Taiwan',
                    // @ts-expect-error 2322
                    district_cn: '台湾地区',
                    // @ts-expect-error 2322
                    district_jp: '台湾',
                },
            ],
            commonConfig,
        );
    } else {
        initGDPR(userId);
    }
}

export default (option?: { hideHeard?: boolean; cb?(userInfo: IUserInfo): void; renderAfter?: () => void }) => {
    applyForceFallback();
    applyFormatActivation();
    document.addEventListener('DOMContentLoaded', watchPictureImgLoad, { once: true });

    const userInfo = getUserInfo();

    option?.renderAfter?.();
    if (!option?.hideHeard) {
        if (userInfo?.umu_id == 0 && !userInfo?.user_name) {
            initHeader({ isMobile: false });
            isInitRegisterBtn();
        } else {
            initHeader({ isMobile: false, userInfo });
            isInitRegisterBtn(userInfo);
        }
    }
    initFooter({ isMobile: false });
    option?.cb?.(userInfo);

    if (SYSTEM.toLowerCase() !== 'cn') {
        showPrompt(userInfo?.umu_id ? String(userInfo.umu_id) : undefined);
    } else {
        registerBesChannels();
    }

    registerSentry();
};

window.VERSION = VERSION;
window.branch = BRANCH;
